import { useState, useEffect } from "react";
import { Button } from "antd";
import { UpOutlined } from "@ant-design/icons";
import {
  Navbar,
  Footer,
  HeroSection,
  AboutSection,
  ProblemsSection,
  ScheduleSection,
  PrizesSection,
  ParticipationSection,
  LocationSection,
  PartnersSection,
  // MentorsSection,
  GallerySection,
  DatasetsSection,
  ProjectsSection,
} from "../component";

export const Home = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    const handleScroll = () => {
      const sections = [
        "home",
        "about",
        "problems",
        "schedule",
        "prizes",
        // "mentors",
        "participation",
        "datasets",
        "projects",
        "gallery",
        "location",
      ];
      const current = sections.find((section) => {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          return rect.top <= 100 && rect.bottom >= 100;
        }
        return false;
      });
      if (current) setActiveSection(current);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setMobileMenuOpen(false);
    }
  };

  const navbar = [
    { label: "Ana Sayfa", section: "home" },
    { label: "Hakkında", section: "about" },
    { label: "Problemler", section: "problems" },
    { label: "Program", section: "schedule" },
    { label: "Ödüller", section: "prizes" },
    // { label: "Mentorler", section: "mentors" },
    { label: "Katılım", section: "participation" },
    { label: "Veri Setleri", section: "datasets" },
    { label: "Projeler", section: "projects" },
    { label: "Galeri", section: "gallery" },
    { label: "Konum", section: "location" },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar
        navbar={navbar}
        activeSection={activeSection}
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
        scrollToSection={scrollToSection}
      />

      <HeroSection />
      <AboutSection />
      <ProblemsSection />
      <ScheduleSection />
      <PrizesSection />
      {/* <MentorsSection /> */}
      <ParticipationSection />
      <DatasetsSection />
      <ProjectsSection />
      <GallerySection />
      <LocationSection />
      <PartnersSection />
      <Footer />

      <Button
        onClick={() => scrollToSection("home")}
        type="text"
        className="fixed bottom-8 right-8 p-3 rounded-full shadow hover:shadow-lg transition"
        icon={<UpOutlined style={{ fontSize: 20 }} />}
      />
    </div>
  );
};
